module.exports = __webpack_public_path__ + "img/step1-c.537e5b30.png";